import { ContentTypeName, DynamicContentType } from '@bm-js/atlascloud-shared'
import DynamicContentSwitcher from './Editor/DynamicContentSwitcher'

type Props = {
  content: DynamicContentType<unknown>
}

const widthByContentType: Partial<Record<ContentTypeName, number>> = {
  calendar: 800,
}

const DEFAULT_WIDTH = 400

const ContentTypeDragItem = ({ content }: Props) => {
  return (
    <div
      className='border border-neutral-500 rounded  p-4 gap-1 bg-white opacity-75 h-20 overflow-y-hidden'
      style={{
        width: widthByContentType[content.name] || DEFAULT_WIDTH,
      }}
    >
      <DynamicContentSwitcher content={content} />
    </div>
  )
}

export default ContentTypeDragItem
